module.exports = __webpack_public_path__ + "img/newyear_gift.0b6b3957.jpg";